import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AnalyticsPage } from '../features/analytics/AnalyticsPage';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { DesignSystemPage } from '../features/design-system/DesignSystemPage';
import { InboxPage } from '../features/inbox/InboxPage';
import { LoginPage } from '../features/auth/LoginPage';
import { ProtectedRoute } from '../features/auth/ProtectedRoute';
import { NotFoundPage } from '../features/not-found/NotFoundPage';
import { ProjectsPage } from '../features/projects/ProjectsPage';
import { SalesPage } from '../features/sales/SalesPage';
import { SettingsPage } from '../features/settings/SettingsPage';
import { TeamPage } from '../features/team/TeamPage';
import { AppLayout } from './layouts/AppLayout';

export const router = createBrowserRouter([
  { path: '/', element: <SalesPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/analytics', element: <Navigate to="/dashboard/analytics" replace /> },
  { path: '/projects', element: <Navigate to="/dashboard/projects" replace /> },
  { path: '/inbox', element: <Navigate to="/dashboard/inbox" replace /> },
  { path: '/team', element: <Navigate to="/dashboard/team" replace /> },
  { path: '/design-system', element: <Navigate to="/dashboard/design-system" replace /> },
  { path: '/settings', element: <Navigate to="/dashboard/settings" replace /> },
  {
    element: <ProtectedRoute />,
    children: [{
      path: '/dashboard',
      element: <AppLayout />,
      children: [
        { index: true, element: <DashboardPage /> },
        { path: 'analytics', element: <AnalyticsPage /> },
        { path: 'projects', element: <ProjectsPage /> },
        { path: 'design-system', element: <DesignSystemPage /> },
        { path: 'inbox', element: <InboxPage /> },
        { path: 'team', element: <TeamPage /> },
        { path: 'settings', element: <SettingsPage /> },
        { path: '*', element: <NotFoundPage /> },
      ],
    }],
  },
  { path: '*', element: <NotFoundPage /> },
]);
